import { Component } from "@angular/core";

@Component({
  selector: "help-view",
  templateUrl: "./help-view.html",
  standalone: false,
})
export class HelpView {}
